//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'tax-info',
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: function _default() {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ratioRules: function ratioRules() {
      if (this.staffInfo.provident_fund_status === '2') return [];
      return [{
        required: true,
        message: this.$t('1593'),
        trigger: 'blur'
      }];
    }
  }
};